import { createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';
import { IUserState } from '../../user/interfaces/user.interface';

export const initialUserState: IUserState = {
    loggedInUser: null,
    publishingTenantId: null,
};

export const userReducer = createReducer(
    initialUserState,
    on(UserActions.setLoggedInUser, (state, { user }) => ({
        ...state,
        loggedInUser: user,
    })),
    on(UserActions.setIsPublishingTenant, (state, { tenantId }) => ({
        ...state,
        publishingTenantId: tenantId ?? null,
    })),
);
